import { Text } from "@mantine/core";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { usePostApi } from "src/hooks";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setShowAutoSaveModal } from "src/redux/slices/generatorSlice";

const DraftAutoSaveModal = () => {
  const dispatch = useDispatch();
  const { logbookId, idType, lbeidOrPartId } = useParams();
  const { post } = usePostApi();
  const opened = useSelector(state => state.generatorSlice.showAutoSaveModal);
  const id = useSelector(state => state.generatorSlice.latestEntry.id);
  const [isSent, setIsSent] = useState(false);
  const sendConfirmation = useCallback(async () => {
    await post({
      request: "auto-save-entry-warn",
      body: {
        params: {
          [String(idType)]: lbeidOrPartId ?? id,
          lbid: logbookId,
        },
      },
    });
  }, [post, idType, lbeidOrPartId, id, logbookId]);

  const handleClose = useCallback(() => {
    dispatch(setShowAutoSaveModal(false));
  }, [dispatch]);

  useEffect(() => {
    if (opened && !isSent) {
      void sendConfirmation();
      setIsSent(true);
      setTimeout(() => {
        handleClose();
      }, 15000);
    }
  }, [opened, sendConfirmation, handleClose, isSent, setIsSent]);

  return opened ? (
    <Text color="gray" size={14}>
      Unless this entry has been saved by confirming your credentials, this auto
      save entry will not count as an official Recorded Entry.
    </Text>
  ) : null;
};

export default DraftAutoSaveModal;
